export default __webpack_public_path__ + "static/media/Apple (4).75fcf3b4.jpg";